import actions from "./actions";

const initState = {
  tests: [],
  subjects: [],
  grades: [],
  schools: [],
  test: null,
  key: null,
  loading: false,
  table_loading: false,
  uploadStatus: false,
  error: "",
  testReport: [],
  lessonReports: [],
  allSchools: [],
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ALL_MCQ_TESTS_SUCCESS:
      return {
        ...state,
        tests: action.tests,
        uploadStatus: false,
      };

    case actions.GET_ALL_SUBJECTS_SUCCESS:
      return {
        ...state,
        subjects: action.subjects,
      };

    case actions.GET_ALL_CLASSES_SUCCESS:
      return {
        ...state,
        grades: action.grades,
      };

    case actions.GET_ALL_SCHOOLS_SUCCESS:
      return {
        ...state,
        schools: action.schools,
      };

    case actions.GET_ALL_SCHOOLS_Data_SUCCESS:
      return {
        ...state,
        allSchools: action.allSchools,
      };

    case actions.UPLOAD_TEST_DETAILS_SUCCESS:
      return {
        ...state,
        uploadStatus: true,
      };

    case actions.SET_MCQ_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case actions.SET_TABLE_LOADING:
      return {
        ...state,
        table_loading: action.loading,
      };

    case actions.SET_MCQ_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };

    case actions.RESET:
      return {
        ...state,
        tests: [],
        subjects: [],
        grades: [],
        test: null,
      };

    case actions.SET_TEST_REPORT:
      return {
        ...state,
        testReport: action.payload.data,
      };

    case actions.GET_LESSON_REPORT_SUCCESS:
      return {
        ...state,
        lessonReports: action.reports,
        loading: false,
      };

    default:
      return state;
  }
}
